import { TextField as MUITextField, Stack, Typography } from "@mui/material";
export const TextField = (props) => {
  const { title, isRequired = false, containerProps, ...restProps } = props;

  // ====================== RETURN
  return (
    <Stack gap={1.25} direction={"column"} {...containerProps}>
      {title && (
        <Typography color="#415058" fontWeight={500} fontSize={".95rem"}>
          {title}
          {isRequired && "*"}
        </Typography>
      )}
      <MUITextField
        placeholder={title}
        FormHelperTextProps={{
          sx: {
            marginLeft: 0,
          },
        }}
        InputProps={{
          sx: {
            borderRadius: ".75rem",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E0E2E4",
            },
            "& .MuiInputBase-input::placeholder": {
              fontStyle: "normal",
            },
          },
        }}
        {...restProps}
      />
    </Stack>
  );
};
